import React from 'react';
import Webcam from "react-webcam";
  
function PayingUsMoney() {
    return (
      <div className="App">
        <header className="App-header">
        Our company uses the most secure blockchain security methods in order to transfer money. You can try it out here.
        No refunds.

        </header>

        <form className = "form">
        <label>
          Credit Card info = 
          <input type="text" name="name" />
        </label>
      </form>
      <form className = "form">
        <label>
          CVV = 
          <input type="text" name="name" />
        </label>
      </form>
      <form className = "form">
        <label>
          Expiration Date = 
          <input type="text" name="name" />
        </label>
        <input type="submit" value="Submit" />
      </form>
      </div>
    );
}
  
  export default PayingUsMoney;
  